import { render } from "./TableComponent.vue?vue&type=template&id=84378524&scoped=true"
import script from "./TableComponent.vue?vue&type=script&lang=js"
export * from "./TableComponent.vue?vue&type=script&lang=js"

import exportComponent from "D:\\code\\h5\\vue-lib\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-84378524"]])

export default __exports__